import { render, staticRenderFns } from "./MyDailyPriorities_Subpage.vue?vue&type=template&id=854ec60c&"
import script from "./MyDailyPriorities_Subpage.vue?vue&type=script&lang=js&"
export * from "./MyDailyPriorities_Subpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports